<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
    <errorPage></errorPage>
  </div>
</template>

<script>
import errorPage from './components/error_dialog_page'
export default {
  name: 'App',
  components: { errorPage },
  data () {
    return {
      isRouterAlive: true
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    reload () {
      // this.isRouterAlive = false
      // this.$nextTick(_ => {
      //   this.isRouterAlive = true
      // })
      var i = sessionStorage.getItem('nowFrameIndex')
      i = i ? parseInt(i) : 0
      var frame = window.frames[i]
      if (frame) {
        frame.postMessage({type: 'reload'}, '*')
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue